/* eslint-disable */
// const state = {
//   variant : null,
//   oilMaker : null,
//   bottleMaker : null,
//   labelMaker : null,
//   month : null,
//   year : null,
// }

const axios = require('axios')
const state = {
  products : null,
  provinsi : null
}

const getters = {
  getProducts: (state) => {
    // console.log(provinsi)
    return state.products
  },
  getProvinsi: (state) => {
    // console.log(provinsi)
    return state.provinsi
  },

  getFilterOptions : (state) => {
    const filterOptions = Object.assign({} , state)
    return filterOptions
  },
}

const mutations = {
 
  productsStatus (state, products) {
    console.log(products)
    if(products){
      state.products = products;
    } else {
      delete state.products
    }
  },
  provinsiStatus (state, provinsi) {
    console.log(provinsi)
    if(provinsi){
      state.provinsi = provinsi;
    } else {
      delete state.provinsi
    }
  },
 
  filterOptionsStatus (state, filterOptions){
    if(filterOptions){
      for (var i in state) state[i] = filterOptions[i] != null ? filterOptions[i] : null;
    } else {
      for (var i in state) delete state[i]
    }
  }
}

const actions = {
  // setVariant ({ commit }, variant){
  //   commit('variantStatus', variant);
  // },
  // setOilMaker ({ commit }, oilMaker){
  //   commit('oilMakerStatus', oilMaker);
  // },
  // setBottleMaker ({ commit }, bottleMaker){
  //   commit('bottleMakerStatus', bottleMaker);
  // },
  // setLabelMaker ({ commit }, labelMaker){
  //   commit('labelMakerStatus', labelMaker);
  // },
  // setMonth ({ commit }, month){
  //   commit('monthStatus', month);
  // },
  // setYear ({ commit }, year){
  //   commit('yearStatus', year);
  // },
  setProducts ({ commit } , data) {
    commit('productsStatus' , data)
  },
  setProvinsi ({ commit } , data) {
    commit('provinsiStatus' , data)
  },
  
}

export default{
  state,
  getters,
  mutations,
  actions
}